import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { calculateSum, getFirebaseDocs, randomString } from '../common'
import Header from '../components/Header'
import Tabs from "../components/Tabs";
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";
import { useGetUserMutation, useKpiRatingsMutation, useOrgsMutation } from "../redux/apiReducer";
import { isSameMonth, subMonths } from "date-fns";
import Table from "../components/Table";

const KpiRatings = () => {

    const [loading, setLoading] = useState(false)
    const [serverError, setServerError] = useState('')
    const [ratingsData, setRatingsData] = useState([])

    const userInfo = useSelector(state => state.user.user)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [fetchKpiRatings, { data: kpiRatingsData, error: kpiRatingsError }] = useKpiRatingsMutation()

    console.log('ratingsData', ratingsData)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                getUserInfo(uid)
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])



    useEffect(() => {
        if (serverError) {
            // Toast.show({ type: 'error', text1: 'Error', text2: serverError })
            setServerError('')
        }
    }, [serverError])

    useEffect(() => {
        if (kpiRatingsData) {
            // console.log('kpiRatingsData', kpiRatingsData)
            if (kpiRatingsData.err) {
                setServerError(kpiRatingsData.err)
                return
            }
            if (kpiRatingsData.data) {
                setRatingsData(kpiRatingsData.data)
            }
        }
    }, [kpiRatingsData])


    useEffect(() => {
        if (kpiRatingsError) {
            console.error('kpiRatingsError', kpiRatingsError)
            if (kpiRatingsError.data && kpiRatingsError.data.err) {
                setServerError(kpiRatingsError.data.err)
            }
        }
    }, [kpiRatingsError])

    useEffect(() => {
        if (userInfo) {
            console.log(userInfo)
            fetchKpiRatings()
        }
    }, [userInfo])

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'staff-users', uid))).data()
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
        // fetchCategories()
    }

    const signOutUser = async () => {
        await auth.signOut();
    }


    return <div className="container">
        <Header />

        <Table
            headers={<thead>
                <th>
                    KPI Name
                </th>
                <th>
                    Total Users
                </th>
                <th>
                    Ratings Received (Total)
                </th>
                <th>
                    Avg Rating
                </th>
                <th>
                    Ratings Received (Current month)
                </th>
                <th>
                    Ratings Received (Past month)
                </th>
            </thead>}
            rows={ratingsData.map(row => <tr key={row.name}>
                <td>{row.name}</td>
                <td>{row.usersWithRating.length}</td>
                <td>{row.values.length}</td>
                <td>{(calculateSum(row.values) / row.values.length).toFixed(2)}</td>
                <td>{row.values.filter(r => isSameMonth(new Date(r.date), new Date())).length}</td>
                <td>{row.values.filter(r => isSameMonth(new Date(r.date), subMonths(new Date(), 1))).length}</td>
            </tr>)}
        />

    </div>
}

export default KpiRatings